const TaskSheet = () => {
  return (
    <div className="flex w-full h-[80vh] justify-center items-center text-4xl font-semibold italic text-gray-400">
      Under Development!!
    </div>
  );
};

export default TaskSheet;
